import React, { useEffect, useState } from 'react';
import { Button, styled } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { LoaderWrapper } from '../sessionHistory';
import { getTeamSurveyResults } from '../../api/adminPanel';
import { Loader } from '../../components/loaders/loader';
import Layout from '../../components/Layout';
import { colors } from '../../styles/globalStyles';
import { Question } from './elements/Question';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../recoil/atoms/userAtom';
import { selectedLanguageAtom } from '../../recoil/atoms/languageAtom';
import textData from '../../data/data.json';

const LargeButton = styled(Button)({
    padding: 22,
    borderRadius: 23,
    transition: 'all 0.3s ease',
    textTransform: 'none',
});

export const TeamSurveyResultsPage = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { teamSurveyResults } = textData[selectedLanguage];
    const navigate = useNavigate();
    const { teamId } = useParams();
    const [questions, setQuestions] = useState([]);
    const [areResultsLoading, setAreResultsLoading] = useState(true);
    const user = useRecoilValue(userAtom);

    useEffect(() => {
        setAreResultsLoading(true);

        getTeamSurveyResults(teamId, selectedLanguage)
            .then((res) => {
                setQuestions(res.data.questions);
                setAreResultsLoading(false);
            })
            .catch((err) => {
                console.error('Ошибка получения ценностей команды', err);
                setAreResultsLoading(false);
            });
    }, []);

    if (areResultsLoading) {
        return (
            <Layout link={`/admin/team/${teamId}`}>
                <LoaderWrapper>
                    <Loader size="large" color={colors.main} />
                </LoaderWrapper>
            </Layout>
        );
    }

    const questionItems = questions?.map((question) => <Question key={question.id} question={question} />) || null;

    return (
        <Layout link={`/admin/team/${teamId}`}>
            {questionItems}
            {!user.areValuesApproved && (
                <LargeButton variant={'colored'} onClick={() => navigate(`/admin/team/${teamId}`)}>
                    {teamSurveyResults.nextButton}
                </LargeButton>
            )}
        </Layout>
    );
};

export default TeamSurveyResultsPage;
